import { createColumnHelper } from '@tanstack/react-table';
import {
    ActionsCell,
    InvitationsRoleCell,
    InvitationStatusCell,
} from './InvitationsCells';
import { Invitation } from 'generated/graphql';

const columnHelper = createColumnHelper<Invitation>();

const InvitationsColumns = [
    columnHelper.accessor('email', {
        header: 'Email',
    }),
    columnHelper.accessor('role', {
        header: 'Role',
        cell: InvitationsRoleCell,
    }),
    columnHelper.accessor('status', {
        header: 'Invitation Status',
        cell: InvitationStatusCell,
    }),
    columnHelper.accessor('id', {
        header: 'Actions',
        cell: ActionsCell,
    }),
];

export default InvitationsColumns;
